module.exports = __webpack_public_path__ + "static/media/ciru.bdbf5ab5.svg";